import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import {AES,enc} from 'crypto-js';

/*
  Generated class for the BaseurlProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class BaseurlProvider {
  // public baseUrl = "http://192.168.1.6/slim/"; 
  public baseUrl = "http://epsilonlogistic.com/api/"; 
  public exportUrl = "https://quote.epsilonlogistic.com/appExports/"; 
  public username = "epsilon";
  public password = "%*#$!)!^#("; 
  secretKey:string = "nolispe"; 
  constructor(public http: Http) {
    //console.log('Hello BaseurlProvider Provider');
  } 
  encrypt(str:string = ''){
    if(str!='' && str!=null && str!=undefined){
    let encryptText = AES.encrypt(str, this.secretKey);
    return encryptText.toString();
    }else{
      return null;
    }
  }
  decrypt(str:string = ''){
    if(str!='' && str!=null && str!=undefined){
      let bytes = AES.decrypt(str, this.secretKey);
      var decryptText = bytes.toString(enc.Utf8);
      return decryptText;
    }else{
      return null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/baseurl/baseurl.ts